export default __webpack_public_path__ + "static/media/21.09c2deec.jpg";